import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static values = {
        url: String,
        text: String,
        title: String,
    }

    connect() {

    }

    async share() {
        if (navigator.share && navigator.canShare) {
            await navigator.share({
                title: this.titleValue,
                text: this.textValue,
                url: this.urlValue
            })
        }
    }
}
